/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { FieldType } from './FieldType.js';
import {
    FieldTypeFromJSON,
    FieldTypeFromJSONTyped,
    FieldTypeToJSON,
} from './FieldType.js';
import type { SearchResultDisplayType } from './SearchResultDisplayType.js';
import {
    SearchResultDisplayTypeFromJSON,
    SearchResultDisplayTypeFromJSONTyped,
    SearchResultDisplayTypeToJSON,
} from './SearchResultDisplayType.js';

/**
 * 
 * @export
 * @interface CreateFieldRequest
 */
export interface CreateFieldRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateFieldRequest
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFieldRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFieldRequest
     */
    placeholder?: string;
    /**
     * 
     * @type {FieldType}
     * @memberof CreateFieldRequest
     */
    type?: FieldType;
    /**
     * 
     * @type {string}
     * @memberof CreateFieldRequest
     */
    options?: string;
    /**
     * 
     * @type {SearchResultDisplayType}
     * @memberof CreateFieldRequest
     */
    searchResultDisplayType?: SearchResultDisplayType;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFieldRequest
     */
    isMultiple?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFieldRequest
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateFieldRequest
     */
    order?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateFieldRequest
     */
    tags?: string;
}

/**
 * Check if a given object implements the CreateFieldRequest interface.
 */
export function instanceOfCreateFieldRequest(value: object): boolean {
    return true;
}

export function CreateFieldRequestFromJSON(json: any): CreateFieldRequest {
    return CreateFieldRequestFromJSONTyped(json, false);
}

export function CreateFieldRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFieldRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'slug': json['slug'] == null ? undefined : json['slug'],
        'name': json['name'] == null ? undefined : json['name'],
        'placeholder': json['placeholder'] == null ? undefined : json['placeholder'],
        'type': json['type'] == null ? undefined : FieldTypeFromJSON(json['type']),
        'options': json['options'] == null ? undefined : json['options'],
        'searchResultDisplayType': json['searchResultDisplayType'] == null ? undefined : SearchResultDisplayTypeFromJSON(json['searchResultDisplayType']),
        'isMultiple': json['isMultiple'] == null ? undefined : json['isMultiple'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'order': json['order'] == null ? undefined : json['order'],
        'tags': json['tags'] == null ? undefined : json['tags'],
    };
}

export function CreateFieldRequestToJSON(value?: CreateFieldRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'slug': value['slug'],
        'name': value['name'],
        'placeholder': value['placeholder'],
        'type': FieldTypeToJSON(value['type']),
        'options': value['options'],
        'searchResultDisplayType': SearchResultDisplayTypeToJSON(value['searchResultDisplayType']),
        'isMultiple': value['isMultiple'],
        'isEnabled': value['isEnabled'],
        'order': value['order'],
        'tags': value['tags'],
    };
}

